import * as trackingHelper from '@/features/searchV2/helpers/tracking';
import { SearchContext } from '@/features/searchV2/types/tracking';
import { DealsSearchState } from '@/reducers/dealsSearchReducer';
import { getSearchPerformedTrackingProps } from '../../tracking';

export function trackSearchPerformed(
  locationName: string,
  context: SearchContext,
  preview: DealsSearchState['preview'],
) {
  const trackingProps = getSearchPerformedTrackingProps({
    type: 'deals_preview',
    urlState: { q: '', location: locationName },
    state: { preview },
    context,
    screenName: 'deals',
  });
  trackingHelper.trackSearchPerformed(trackingProps);
}
